import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismInput } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import { not, or } from 'ember-truth-helpers';
import type PasswordResetController from 'frontend-login/controllers/password-reset';
import { contextualPageTitle } from 'frontend-utils';
import { LoginCard, LoginCardFooter } from 'password-form';

interface PasswordResetSignature {
  controller: PasswordResetController;
}

<template>
  {{pageTitle (contextualPageTitle (t "login.forgot_your_password"))}}

  {{#if @controller.success}}
    <LoginCard
      @explanation={{t "forgot_your_password.success.note"}}
      @onBackButtonClicked={{@controller.goBack}}
      @showBackButton={{true}}
      @title={{t "forgot_your_password.success.title"}}
    />
  {{else}}
    <LoginCard
      @explanation={{t "forgot_your_password.note"}}
      @onBackButtonClicked={{@controller.goBack}}
      @showBackButton={{true}}
      @title={{t "login.forgot_your_password"}}
    >
      <div class="flex flex-col gap-400">
        <PrismInput
          @autofocus={{true}}
          @errorMessage={{if
            @controller.hasServerError
            (t "login.error.general")
            (t "login.email.error")
          }}
          @hasErrors={{or
            (not @controller.isEmailValid)
            @controller.hasServerError
          }}
          @label={{t "login.email"}}
          @name="email"
          @onInput={{@controller.setEmail}}
          @onKeyDown={{@controller.submitFormWithEnter}}
          @removePadding={{true}}
          @type="email"
          @value={{@controller.email}}
          data-test-id="input-email"
        />

        <PrismButton
          @isDisabled={{not @controller.isEmailValid}}
          @label={{t "forgot_your_password.reset"}}
          @onClick={{@controller.resetPassword}}
          data-test-id="button-reset-password"
        />
      </div>

      <LoginCardFooter
        @showContactSuccess={{true}}
        @showSignUpForTrial={{true}}
      />
    </LoginCard>
  {{/if}}
</template> satisfies TOC<PasswordResetSignature>;
